/**
 * @file money.js
 * @description 金额单位转换工具
 */

/**
 * 分转元，保留两位小数
 * @param {number|string} fen 金额（分）
 * @returns {string} 元字符串，如 12345 -> "123.45"
 */
export const fenToYuan = (fen) => {
  const num = Number(fen);
  if (Number.isNaN(num)) return "0.00";
  return (num / 100).toFixed(2);
};
